import React from 'react'
import { Datagrid, TextField } from 'react-admin'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import KList from 'ui-shared/KWrappers/KList'

const RuleList: React.FC<BaseListProps> = (props) => {
  return (
    <SectionWrapper>
      <KList {...props} exporter={false} pagination={false}>
        <Datagrid rowClick="edit">
          <TextField source="name" sortable={false} />
        </Datagrid>
      </KList>
    </SectionWrapper>
  )
}

export default RuleList
